import { useState } from 'react';
import { downloadReportExport } from '@/api/reports';
import { Button } from '@/components/ui/Button';
import { Alert } from '@/components/ui/Alert';

export function ExportButton({ reportId, baseUrl }: { reportId: string; baseUrl: string }) {
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);

  async function onClick() {
    setBusy(true);
    setFailed(false);
    try {
      await downloadReportExport(reportId, baseUrl);
    } catch {
      setFailed(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10, margin: '4px 0 -8px' }}>
      {failed && <Alert variant="error">Échec de l&apos;export — veuillez réessayer.</Alert>}
      <Button variant="ghost" onClick={onClick} loading={busy} loadingText="Exportation en cours…" title="Télécharger l'export Excel">
        ⬇ Exporter vers Excel
      </Button>
    </div>
  );
}
